import React, { RefObject } from 'react';
import Typography from '@material-ui/core/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { Paper } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useStyles } from './css';

export function PageNotFound() {
    const classes = useStyles();

    const AppStoreHomeLink = React.forwardRef((props, ref: RefObject<HTMLAnchorElement>) => (
        <RouterLink ref={ref} to="/" {...props} />
    ));
    const DeveloperLink = React.forwardRef((props, ref: RefObject<HTMLAnchorElement>) => (
        <RouterLink ref={ref} to="/developer" {...props} />
    ));

    return (
        <main>
            <Container maxWidth="lg">
                <Paper elevation={2} className={classes.paddedContainer}>
                    <Typography component="h4" variant="h4" align="center" gutterBottom>
                        Page not found
                    </Typography>
                    <Typography variant="h5" align="center" color="textSecondary" paragraph>
                        Sorry, that page does not exist.
                    </Typography>
                    <div className={classes.heroButtons}>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component={AppStoreHomeLink}
                                >
                                    Open the App Store
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    component={DeveloperLink}
                                >
                                    Go to Developer Portal
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Paper>
            </Container>
        </main>
    );
}
